import { Box, Progress, VStack } from '@televet/kibble-ui/build/chakra';
import { Heading } from '@televet/kibble-ui/build/components/Heading';
import type { NextPage } from 'next';
import { useEffect, useCallback } from 'react';
import { useAuth } from '../shared/providers/auth/authProvider';
import { useRouter } from 'next/router';
import { getPawblisherLoginUrl, getRedirectUrl, isPawblisherRedirect } from '../shared/utils/getRedirectUrl';

const Logout: NextPage = () => {
  const { logout } = useAuth();
  const router = useRouter();

  const forceLogout = useCallback(async () => {
    const redirect = isPawblisherRedirect() ? getPawblisherLoginUrl() : getRedirectUrl();

    await logout();
    router.push(`/${redirect ? `?${redirect}` : ''}`);
  }, [logout, router]);

  useEffect(() => {
    forceLogout();
  }, [forceLogout]);

  return (
    <VStack spacing={4}>
      <Box width="320px">
        <Heading size="md">Logging out...</Heading>
        <Progress mt="25px" size="xs" colorScheme="primary" isIndeterminate />
      </Box>
    </VStack>
  );
};

export default Logout;
